import { SkeletonLoader } from '@payaca/ambrosia';
import PipelineStage from '@payaca/components/pipelineStage/PipelineStage';
import { FC } from 'react';

const PipelinePageSkeleton: FC = () => (
  <div className="h-full flex flex-col">
    <div className="flex justify-between items-center m-4 pb-0">
      <SkeletonLoader className="h-9 w-48 rounded-lg" />
      <SkeletonLoader className="h-8 w-32 rounded-lg" />
    </div>

    <div className="border-b" />

    <div className="flex flex-col gap-4 md:flex-row justify-between md:items-center p-4 pb-0">
      <div className="flex items-center gap-2 flex-wrap">
        <SkeletonLoader className="h-9 w-32 rounded-lg" />
        <SkeletonLoader className="h-9 w-28 rounded-lg" />
        <SkeletonLoader className="h-9 w-28 rounded-lg" />
      </div>
      <div className="flex items-center gap-4">
        <SkeletonLoader className="h-9 w-36 rounded-lg" />
        <SkeletonLoader className="h-9 w-24 rounded-lg" />
      </div>
    </div>

    <div className="flex gap-4 w-full flex-1 p-4 overflow-x-auto">
      {Array.from({ length: 6 }).map((_, i) => (
        <PipelineStage.SkeletonLoader key={i} className="min-w-80" />
      ))}
    </div>
  </div>
);

export default PipelinePageSkeleton;
